/*
 * localStorage throws rather than returning null in a few real situations
 * (Safari private browsing, cookies blocked, an embedded webview), so every
 * read and write goes through here and falls back to the caller's default.
 */
export const readStored = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeStored = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* Preference just won't survive a reload. */
  }
};
